<template>
  <div class="m_table">
    <ul class="m_table_ul">
      <li class="m_table_li"
          v-for="(item, index) in items"
          :key="index">
        <div class="col">
          <div class="tag" :class="{'light_grey' : item.edu.isEnd === 2}">
            <span>{{ item.edu.isEnd === 1 ? '수료완료' : item.edu.isEnd === 2 && item.isTraining === 1 ? '수강기간 만료' : '미수료' }}</span>
          </div>
          <div class="m_table_ttl">
            <span>{{ $ConstCode.CODE_SALES_TYPE[item.edu.salesType].name }} ({{ $ConstCode.CODE_INDUSTRY_TYPE[item.edu.industryType].name }})</span><br>
            <span>{{ item.edu.businessName }}</span>
          </div>
          <div class="date"><span>{{ $moment(item.edu.regDate).format('YYYY.MM.DD') }}</span></div>
        </div>
        <div class="col fix110">
          <button class="btn bo" @click="fnStudy(item)" :disabled="item.isTraining === 1">바로가기</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'edu-study-list-index',
  props: {
    items: {
      type: [Array, Object],
      default: () => {}
    },
    pageInfo: {
      type: [Array, Object],
      default: () => {}
    }
  },
  methods: {
    fnStudy: function(item) {
      this.$emit('study', item)
    }
  }
}
</script>

<style scoped>

</style>
